import { ACD_DATAS_2 } from "../../../constants/acd";

const anchorStyle = (color = "white") => ({
  color: color,
  borderWidth: 0,
});

const anchorSize = 8;

const dataSetting = ({ color, name, data }) => ({
  name: name,
  type: "line",
  areaStyle: {
    color: `${color}20`,
  },
  lineStyle: {
    color: color,
  },
  emphasis: {
    focus: "series",
  },
  symbolSize: anchorSize,
  symbol: "circle",
  itemStyle: anchorStyle(color),
  data: data,
});

function chartConfig(labels, data) {
  return {
    title: {
      show: false,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#6a7985",
        },
      },
    },
    legend: {
      show: false,
      data: Object.keys(ACD_DATAS_2).map((key) => ACD_DATAS_2[key].name),
    },
    toolbox: {
      show: false,
      feature: {
        saveAsImage: {},
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      top: "5%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel:{
          color: "white",
          fontSize: 12,
        },
        data: labels,
      },
    ],
    yAxis: [
      {
        type: "value",
        splitLine: {
          show: false,
        },
        axisLabel:{
          fontSize: 11,
          fontWeight: 600,
          color: "white",
        },
        splitNumber:3,
      },
    ],
    series: data.map(item => dataSetting(item)),
  };
}

export { chartConfig, dataSetting };
